import {UmpireComponent, UmpireImage} from '..';
import {UmpireComponentTypeEnum} from '../umpire-component-type-enum';

export interface UmpireComponentContact
  extends UmpireComponent<UmpireComponentTypeEnum.CONTACT> {
  contacts: UmpireContact[];
  contacts_order: ContactOrder[];
  header: string;
}

export interface ContactOrder {
  contact_id: string;
  contact_index: number;
}

export interface UmpireContact {
  id?: string;
  type: 'contact';
  tagline: string;
  title: string;
  body: string;
  button_enabled: boolean;
  button_text: string;
  button_external_url: string;
  image: UmpireImage;
  relationshipNames: string[];
}
